export default __webpack_public_path__ + "static/media/CRChurchill.86e6b621.png";